import React from 'react';

export default function Secret() {
  return <div>Secret Content - Only accessible if logged in!</div>;
}
